import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import angular from 'angular';
import { HelpersServiceModule } from '../helpers/helpers.service';

export const ReviewsServiceModule = angular.module('acme.common.service.reviews', [
  HelpersServiceModule,
  ApiVersionFactoryModule
])
.service('ReviewsService', [ '$http', 'HelpersService', 'ApiVersionFactory', function($http, HelpersService, ApiVersionFactory) {

    return {

      api: {

        av_reviews: new ApiVersionFactory({
          url: '/v1/b2c/reviews',
          version: 'v2'
        }),

        list: function(props) {
          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_reviews.url + '/' + props.eventTemplateId
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_reviews.url + '/' + props.reviewToken,
            data: {
              visitorId: props.visitorId,
              tenantId: props.tenantId,
              eventTemplateId: props.eventTemplateId,
              rating: props.rating,
              title: props.title,
              comment: props.comment
            }
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_reviews.url,
            data: {
              id: props.id,
              visitorId: props.visitorId,
              tenantId: props.tenantId,
              eventTemplateId: props.eventTemplateId,
              rating: props.rating,
              title: props.title,
              comment: props.comment
            }
          });
        },

        program: {

          av_reviews_program: new ApiVersionFactory({
            url: '/v1/b2c/reviews/program',
            version: 'v2'
          }),

          list: function(props) {

            var q,
                query = $.extend({}, props);

            delete query.eventTemplateId;
            delete query.tenantId;

            q = HelpersService.parametrize(query);

            console.log('ReviewsService::program::list', q, query, props);

            return $http({
              method: 'get',
              headers: {
                'x-b2c-tenant-id': props.tenantId
              },
              url: this.av_reviews_program.url + '/' + props.eventTemplateId + q
            });
          }
        },

        visitor: {

          av_reviews_visitor: new ApiVersionFactory({
            url: '/v1/b2c/reviews/visitor',
            version: 'v2'
          }),

          list: function(props) {

            return $http({
              method: 'get',
              headers: {
                'x-b2c-tenant-id': props.tenantId
              },
              url: this.av_reviews_visitor.url + '/' + props.visitorId
            });
          }
        },

        tenant: {

          av_reviews_tenant: new ApiVersionFactory({
            url: '/v1/b2c/reviews/tenant',
            version: 'v2'
          }),

          av_reviews_tenant_summaries: new ApiVersionFactory({
            url: '/v1/b2c/review/summaries/tenant/',
            version: 'v2'
          }),

          list: function(props) {

            var q,
                query = $.extend({}, props);

            delete query.tenantId;

            q = HelpersService.parametrize(query);

            return $http({
              method: 'get',
              headers: {
                'x-b2c-tenant-id': props.tenantId
              },
              url: this.av_reviews_tenant.url + '/' + props.tenantId + q
            });
          },

          summary: function(tenantId) {
            return $http({
              method: 'get',
              headers: {
                'x-b2c-tenant-id': tenantId
              },
              url: this.av_reviews_tenant_summaries.url + tenantId
            });
          }
        }

      },

      init: function(tenantId) {
        return this.api.tenant.summary(tenantId);
      }

    };

}]).name;